import Material from '@components/common/faq-material'
import { FAQ } from '@lib/data/course-landing-page'
import { useState } from 'react'

type Props = {
  courseName: string
  title?: string
}

const Faq = ({ courseName, title }: Props) => {
  const [activeAccordion, setActiveAccordion] = useState('')

  return (
    <div className="container mx-auto mt-10 lg:px-3 pt-5 mb-12 md:mb-16">
      <h2 className="text-2xl font-600 mb-10 leading-tight">
        {title ? title : 'Frequently Asked Questions'}
      </h2>
      {FAQ[courseName].map(({ questionName, acceptedAnswerJsx }, index) => (
        <Material
          key={index}
          title={questionName}
          activeAccordion={activeAccordion}
          setActiveAccordion={setActiveAccordion}
        >
          <p className="text-base">{acceptedAnswerJsx}</p>
        </Material>
      ))}
    </div>
  )
}

export default Faq
